enum FileEntryStatus {
    WAITING = 1,
    UPLOADING,
    SUCCESSFUL,
    ERROR,
}

export default FileEntryStatus;
